import QuestionLayout from "./QuestionLayout";

const WHITE_KEY_WIDTH = 54;
const WHITE_KEY_HEIGHT = 180;
const BLACK_KEY_WIDTH = 34;
const BLACK_KEY_HEIGHT = 105;

const BLACK_KEYS_AFTER = {
  C: "C#",
  D: "D#",
  F: "F#",
  G: "G#",
  A: "A#"
};

function normalizeLetter(input) {
  if (!input) return "";

  const s = String(input).trim().toUpperCase();
  return /^[A-G]$/.test(s) ? s : s.slice(0, 1);
}

export default function KeyboardLetterFillWidget({
  config,
  value = {},
  onChange,
  mode = "edit",
  feedback
}) {
  const whiteKeys = (config.whiteKeys || ["C", "D", "E", "F", "G", "A", "B"]).map(
    (key) =>
        typeof key === "string"
        ? { id: key, label: key }
        : key
    );
  const answers = value.answers || {};

  function updateKey(key, nextValue) {
    if (mode !== "edit") return;

    onChange({
      ...value,
      answers: {
        ...answers,
        [key]: normalizeLetter(nextValue)
      }
    });
  }

  function keyFeedback(key) {
    return feedback?.parts?.[key] ?? null;
  }

  function inputStyle(key) {
    const fb = keyFeedback(key);

    let border = "1px solid #999";

    if (mode === "review") {
      border = fb?.correct ? "2px solid #2e7d32" : "2px solid #c62828";
    }

    return {
      width: 30,
      height: 28,
      textAlign: "center",
      fontSize: 18,
      fontWeight: "bold",
      border,
      borderRadius: 4,
      textTransform: "uppercase",
      background: mode === "review" ? "#fff" : "white"
    };
  }

  const keyboardWidth = whiteKeys.length * WHITE_KEY_WIDTH;

  return (
    <QuestionLayout
      number={config.number}
      prompt={config.prompt}
      points={config.points}
      mode={mode}
      feedback={feedback}
    >
      <div
        style={{
          display: "flex",
          gap: 28,
          alignItems: "center"
        }}
      >
        {config.referenceImage && (
          <img
            src={config.referenceImage}
            alt=""
            style={{
              width: config.referenceImageWidth || 160,
              height: "auto",
              objectFit: "contain"
            }}
          />
        )}

        <div>
          {/* {Array.isArray(config.letters) && (
            <div
              style={{
                marginBottom: 12,
                fontSize: 18,
                fontWeight: "bold",
                letterSpacing: 8
              }}
            >
              {config.letters.join(" ")}
            </div>
          )} */}

          <div
            style={{
              position: "relative",
              width: keyboardWidth,
              height: WHITE_KEY_HEIGHT
            }}
          >
            {/* white keys */}
            {whiteKeys.map((key, index) => (
            <div
                key={key.id}
                style={{
                  position: "absolute",
                  left: index * WHITE_KEY_WIDTH,
                  top: 0,
                  width: WHITE_KEY_WIDTH,
                  height: WHITE_KEY_HEIGHT,
                  border: "1px solid #111",
                  background: "white",
                  boxSizing: "border-box",
                  display: "flex",
                  alignItems: "flex-end",
                  justifyContent: "center",
                  paddingBottom: 14
                }}
              >
                {config.inputKeys?.includes(key.id) ?? true ? (
                <input
                    value={answers[key.id] || ""}
                    disabled={mode === "review"}
                    maxLength={1}
                    onChange={(e) => updateKey(key.id, e.target.value)}
                    style={inputStyle(key.id)}
                />
                ) : null}
              </div>
            ))}

            {/* black keys */}
            {whiteKeys.map((key, index) => {
            if (!BLACK_KEYS_AFTER[key.label]) return null;

              return (
                <div
                  key={BLACK_KEYS_AFTER[key.label] + key.id}
                  style={{
                    position: "absolute",
                    left:
                      index * WHITE_KEY_WIDTH +
                      WHITE_KEY_WIDTH -
                      BLACK_KEY_WIDTH / 2,
                    top: 0,
                    width: BLACK_KEY_WIDTH,
                    height: BLACK_KEY_HEIGHT,
                    background: "#111",
                    borderRadius: "0 0 4px 4px",
                    zIndex: 2
                  }}
                />
              );
            })}
          </div>
        </div>
      </div>
    </QuestionLayout>
  );
}